export default __webpack_public_path__ + "static/media/Radio_button-unchecked.43401b31.svg";